/**
 * The prompt shown when a `?team_id=` link meets a registration already in
 * progress in this browser. Kept in one place so the wording can change
 * without touching the page that shows it.
 */
export const SESSION_LINK_CONFLICT_COPY = {
  title: 'You Have A Running Session',
  description: 'Do you want to start over with the new registration link?',
  cancelLabel: 'CANCEL',
  confirmLabel: 'START OVER',
} as const

/**
 * Jeff, Oct 1 — an `?invite=` link the server no longer honours (the invite was
 * cancelled, changed, or already used). The wizard opens an ordinary session
 * instead and says so once: the reader can still register if a spot is open.
 */
export const STALE_INVITE_COPY = {
  title: 'Invitation No Longer Active',
  description:
    'This invitation is no longer active — you can still register if a spot is open.',
  confirmLabel: 'OK',
} as const
